const styleSheet = () => ({
  toast: {
    zIndex: 100001,
    borderRadius: "4px",
    backgroundColor: "#00B388",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.49)",
    padding: "15px 24px",
    position: "fixed",
    textAlign: "center",
    left: "50%",
    transform: "translateX(-50%)",
    width: "204px",
    overflowWrap: "break-word",
    height: "48px",
    cursor: "pointer",
    outline: "none",
    border: "none",
  },
  text: {
    color: "#fff",
    fontSize: "14px",
    fontweight: "500",
    lineHeight: "18px",
    height: "18px",
    width: "156px",
    fontFamily: ({ theme }) => theme.fontFamily,
  },
  top: {
    top: "5px",
  },
  bottom: {
    bottom: "40px",
  },
});

export default styleSheet;
